import React from "react";
import { Dropdown } from "antd";
import AppIcon from './AppIcon'

const AppDropDown=({
    dropdownMenu=[],
    icon='',
    onItemClick
}
    
)=>{
    return(
        <Dropdown menu={{ items: dropdownMenu, onClick:({key})=>onItemClick(key) }} trigger={["click"]} placement="bottomRight"  overlayClassName="app-action-dropdown">
            <span className="cursor-pointer" >
               <AppIcon name={icon} />  
            </span>
        </Dropdown>
    )

}

export default AppDropDown

